import { _ } from "../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import CountWidget from "./CountWidget/CountWidget.js";

/**
 * Widget that renders a one-line list of elements, with a limit of visible
 * elements rendered.  The number of hidden elements is displayed as a
 * counter tag.
 *
 * @param {Renderable[]} spec.elements - All renderable elements of the listing.
 * @param {string} [spec.visibleElementCssClass] - CSS class used around each
 * visible element.
 * @param {number} [spec.maxVisibleElements] - Number of visible
 * elements. Extra elements will be hidden.
 * @param {Renderable} [spec.separator] - Renderable placed between each element.
 */
export default class InlineListingWidget extends Widget {
	constructor({
		elements = [],
		maxVisibleElements = 3,
		visibleElementCssClass = "",
		separator = ", ",
	} = {}) {
		super(...arguments);
		this._maxVisibleElements = maxVisibleElements;
		this._elements = elements;
		this._visibleElementCssClass = visibleElementCssClass;
		this._separator = separator;
	}

	renderContentOn(html) {
		html.span(
			{ klass: "inline-listing" },
			html.ul(
				this._renderVisibleElementsOn.bind(this),
				this._renderOverflowingElementsOn.bind(this),
			),
		);
	}

	_renderVisibleElementsOn(html) {
		html.render(
			this._visibleElements().map((elt, i) =>
				html.li(
					{ klass: this._visibleElementCssClass },
					i === 0 ? "" : this._separator,
					elt,
				),
			),
		);
	}

	_renderOverflowingElementsOn(html) {
		const elements = this._overflowingElements();
		if (elements.length) {
			html.li(
				this._separator,
				html.span(
					{ klass: "overflowing" },
					"+",
					new CountWidget({
						elements,
						label: _("other"),
						pluralLabel: _("others"),
					}),
				),
			);
		}
	}

	_visibleElements() {
		return this._elements.slice(0, this._maxVisibleElements);
	}

	_overflowingElements() {
		return this._elements.slice(this._maxVisibleElements);
	}
}
